{
  "name": "fastshop.backoffice.frontend",
  "version": "1.0.52",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build:sentry": "ng build && npm run sentry:sourcemaps",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org quality --project fastshop-backoffice-angular ./dist && sentry-cli --url https://sentry.ftwmasters.com.br/ sourcemaps upload --org quality --project fastshop-backoffice-angular ./dist"
  },
  "prettier": {
    "printWidth": 100,
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.8",
    "@angular/common": "^21.2.8",
    "@angular/compiler": "^21.2.8",
    "@angular/core": "^21.2.8",
    "@angular/forms": "^21.2.8",
    "@angular/platform-browser": "^21.2.8",
    "@angular/platform-browser-dynamic": "^21.2.8",
    "@angular/router": "^21.2.8",
    "@angular/cdk": "^21.2.6",
    "@ng-select/ng-select": "^21.8.0",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@primeuix/themes": "^2.0.3",
    "@sentry/angular": "^10.47.0",
    "@sentry/cli": "^3.3.5",
    "@tailwindcss/forms": "^0.5.11",
    "@types/feather-icons": "^4.29.4",
    "fabric": "^7.2.0",
    "feather-icons": "^4.29.2",
    "lightgallery": "^2.9.0",
    "monaco-editor": "^0.55.1",
    "ng-click-outside2": "^19.0.0",
    "ngx-countup": "^21.0.0",
    "ngx-monaco-editor-v2": "^21.1.4",
    "primeng": "^21.1.5",
    "rxjs": "~7.8.2",
    "simplebar": "^6.3.3",
    "simplebar-angular": "^3.3.2",
    "tailwindcss-primeui": "^0.6.1",
    "tiny-slider": "^2.9.4",
    "tslib": "^2.8.1",
    "zone.js": "~0.16.1"
  },
  "devDependencies": {
    "@angular/build": "^21.2.7",
    "@angular/cli": "^21.2.7",
    "@angular/compiler-cli": "^21.2.8",
    "@types/jasmine": "~6.0.0",
    "autoprefixer": "^10.4.27",
    "jasmine-core": "~6.1.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.2.0",
    "postcss": "^8.5.9",
    "tailwindcss": "^3.4.19",
    "typescript": "~5.9.3"
  }
}
